import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Filters from '@/util/filters';
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Filters);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
